<template>
  <div
    class="ai-suggest-bar"
    v-if="visible"
    :class="{ 'is-collapsed': collapsed }"
  >
    <div class="ai-suggest-bar__head">
      <span
        class="ai-suggest-bar__label"
        @click="collapsed && toggleCollapse()"
      >
        智能话术<em v-if="items.length">{{ items.length }}</em>
      </span>
      <div class="ai-suggest-bar__actions">
        <button
          type="button"
          class="ai-suggest-bar__btn"
          @click="toggleCollapse"
        >
          {{ collapsed ? "展开" : "收起" }}
        </button>
        <button type="button" class="ai-suggest-bar__btn" @click="dismiss">
          ×
        </button>
      </div>
    </div>

    <div class="ai-suggest-bar__list" v-show="!collapsed">
      <button
        v-for="(item, index) in items"
        :key="item.id || index"
        type="button"
        class="ai-suggest-bar__chip"
        @click="useItem(item)"
      >
        <span class="ai-suggest-bar__meta">
          <b>{{ index + 1 }}</b>
          <i v-if="item.modelName">{{ item.modelName }}</i>
        </span>
        <span class="ai-suggest-bar__text">{{ item.content }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiSuggestBar",
  computed: {
    suggest() {
      return this.$store.state.aiAssistantSuggest || {};
    },
    collapsed() {
      return !!this.suggest.collapsed;
    },
    currentClient() {
      if (this.$store.state.colleageAngle) {
        return this.$store.state.college.nowSelectClient;
      }
      return this.$store.state.selectedClient;
    },
    items() {
      const list = this.suggest.items || [];
      const cid = this.suggest.cid;
      const sid = this.suggest.sid;
      const client = this.currentClient;
      if (!client) return [];
      if (cid && client.cid && cid !== client.cid) return [];
      if (sid && client.sid && sid !== client.sid) return [];
      return list;
    },
    visible() {
      return this.items.length > 0;
    },
  },
  methods: {
    useItem(item) {
      if (!item || !item.content) return;
      this.$emit("use", item.content);
    },
    toggleCollapse() {
      this.$store.commit("collapseAiAssistantSuggest", !this.collapsed);
    },
    dismiss() {
      this.$store.commit("clearAiAssistantSuggest");
    },
  },
};
</script>

<style scoped lang="scss">
.ai-suggest-bar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 8px 5px;
  padding: 6px 8px;
  background: #f5f9ff;
  border: 1px solid #d6e4f5;
  border-radius: 4px;
}

.ai-suggest-bar__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ai-suggest-bar__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #3a6aa8;
  white-space: nowrap;
  cursor: default;
  line-height: 1;

  em {
    font-style: normal;
    min-width: 16px;
    padding: 0 5px;
    border-radius: 8px;
    background: #3a6aa8;
    color: #fff;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
  }
}

.is-collapsed .ai-suggest-bar__label {
  cursor: pointer;
}

.ai-suggest-bar__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 180px;
  overflow-x: hidden;
  overflow-y: auto;
}

.ai-suggest-bar__list::-webkit-scrollbar {
  width: 4px;
}

.ai-suggest-bar__list::-webkit-scrollbar-thumb {
  background: #c5d4e8;
  border-radius: 2px;
}

.ai-suggest-bar__chip {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid #c9d9ef;
  border-radius: 4px;
  background: #fff;
  color: #334155;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
}

.ai-suggest-bar__chip:hover {
  border-color: #3a6aa8;
  background: #f8fbff;
  color: #1f4e8c;
}

.ai-suggest-bar__meta {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 1px;
  line-height: 1.45;

  b {
    flex: none;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: #3a6aa8;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
  }

  i {
    font-style: normal;
    color: #5a7eae;
    font-size: 12px;
    white-space: nowrap;
  }
}

.ai-suggest-bar__text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.ai-suggest-bar__actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ai-suggest-bar__btn {
  border: none;
  background: transparent;
  color: #7a93b5;
  cursor: pointer;
  padding: 0 4px;
  font-size: 13px;
  line-height: 20px;
}

.ai-suggest-bar__btn:hover {
  color: #1f4e8c;
}
</style>
